import normalizeApiResponse from 'utils/normalizeApiResponse';

import { createEntityResponse } from 'utils/reduxHelpers';

import {
    DELETED_PROCESS,
    DELETING_PROCESS,
    DISMISS_ALERT,
    DISMISSED_PROCESS,
    DISMISSING_PROCESS,
    DISPLAY_ALERT,
    LOADED_PROCESSES,
    LOADING_PROCESSES,
    MAXIMIZE_PROCESS_TRACKER,
    MINIMIZE_PROCESS_TRACKER,
    START_POLLING_PROCESSES,
    STOP_POLLING_PROCESSES,
    REFRESH_ON_COMPLETED_BUTTONS,
} from '../constants/actionTypes';

import { processesSchema } from '../schemas';

/**
 * ProcessTracker Action Creators
 * ==============================
 *
 * Action Creators for the ProcessTracker component. These should be abstracted once
 * we determine the pattern we want to use for more complex components with their
 * own actions.
 */
export const loadingProcesses = () => ({
    type: LOADING_PROCESSES,
});

export const loadedProcesses = (response) => ({
    type: LOADED_PROCESSES,
    payload: normalizeApiResponse(response.data, processesSchema),
});

export const dismissingProcess = (processId) => ({
    type: DISMISSING_PROCESS,
    payload: createEntityResponse('processes', processId, {
        isDismissing: true,
    }),
});

export const dismissedProcess = (processId) => ({
    type: DISMISSED_PROCESS,
    payload: createEntityResponse('processes', processId, {
        dismissed: true,
        isDismissing: false,
    }),
});

export const deletingProcess = (processId, isCompleted) => ({
    type: DELETING_PROCESS,
    payload: createEntityResponse('processes', processId, {
        isDeleting: true,
        isCompleted,
    }),
});

export const deletedProcess = (processId, isCompleted) => ({
    type: DELETED_PROCESS,
    payload: createEntityResponse('processes', processId, {
        deleted: true,
        isDeleting: false,
        isCompleted,
    }),
});

export const startedPollingProcesses = () => ({
    type: START_POLLING_PROCESSES,
});

export const stoppedPollingProcesses = () => ({
    type: STOP_POLLING_PROCESSES,
});

export const minimizeProcessTracker = () => ({
    type: MINIMIZE_PROCESS_TRACKER,
});

export const maximizeProcessTracker = () => ({
    type: MAXIMIZE_PROCESS_TRACKER,
});

export const refreshOnCompletedButtons = () => ({
    type: REFRESH_ON_COMPLETED_BUTTONS,
});

export const displayAlert = (alertChildren, alertAction) => ({
    type: DISPLAY_ALERT,
    alertChildren,
    alertAction,
});

export const dismissAlert = () => ({ type: DISMISS_ALERT });

export const displayError = (errorMessage, onClickOkay) =>
    displayAlert(errorMessage, {
        label: 'Okay',
        keyboardFocused: true,
        onClick: (e) => {
            onClickOkay(e);
        },
    });
